import { tv } from '~/utils/tv'

export const InputCounterRootVariants = tv({
  base: 'flex w-full min-w-[calc(var(--sizing-colossal)_+_var(--sizing-micro))] flex-col gap-halfpulse ',
  variants: {},
})
